import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableTBodyCell as ClbTableTBodyCell_ } from '@celebration/design-system/dist/lib/table-tbody-cell';
export const ClbTableTBodyCell = createComponent({
    tagName: ClbTableTBodyCell_.tagName,
    elementClass: ClbTableTBodyCell_,
    react: React,
    events: {},
});
//# sourceMappingURL=index.js.map